import { selectLiveTasks } from '@/store/notification/selectors';
import { useGetTaskSnapshotQuery } from '@/store/query/tasks';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from './NavLink';
import { Calendar } from '@/assets/icons/nav-v2';
import { usePermissionGuard } from '@/hooks/usePermissionGuard';
import { useGetTasksMetricsQuery } from '@/store/query/dashboard';
import { useAtsPermissions } from '@/hooks/useAtsPermissions';
import { useKFlags } from '@/hooks/use-k-flags';
import { useRequisitionsEnabled } from '@/pages/requisitions/hooks';

export const TaskNav = ({ isCollapsed }) => {
  const liveTasks = useSelector(selectLiveTasks);
  const { isFlowEnabled } = usePermissionGuard();
  const { isJobsVisible } = useAtsPermissions();
  const { ats_enabled } = useKFlags();
  const { isEnabled: isRequisitionsEnabled } = useRequisitionsEnabled();

  const { data: tasks = {}, refetch } = useGetTaskSnapshotQuery(
    {},
    { skip: !isFlowEnabled }
  );
  const { data: jobTasksData = {} } = useGetTasksMetricsQuery(
    {},
    { skip: !isJobsVisible }
  );
  const { counts: jobTasksCount = {} } = jobTasksData;
  const {
    job_approval = 0,
    offer_approval = 0,
    scorecard = 0,
    requisition_approval = 0,
  } = jobTasksCount;

  const jobTaskCount =
    job_approval +
    offer_approval +
    scorecard +
    (isRequisitionsEnabled ? requisition_approval : 0);

  const pendingTasks =
    (tasks?.pending_counts?.today || 0) + (tasks?.pending_counts?.past || 0);

  const totalTasksCount = pendingTasks + jobTaskCount;

  useEffect(() => {
    if (!isFlowEnabled) return;
    refetch();
  }, [liveTasks]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <NavLink
      link={ats_enabled ? '/tasks/jobs/scorecard' : '/tasks'}
      count={totalTasksCount}
      title="Tasks"
      icon={Calendar}
      isCollapsed={isCollapsed}
    />
  );
};
